import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const ServiceabilityBasicInfoComponent = ({ onInnerBasicFormChange, selectedServiceabilitys, vendors }: any) => (

  <><AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer

          label="Active"
          name="IsActive"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event,
              'IsActive'

            )
          }}
          type="checkbox"
          value={selectedServiceabilitys?.IsActive}
        />

        <InputContainer

          label="Name"
          name="Name"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'Name'

            )
          }}
          type="text"
          value={selectedServiceabilitys?.Name}
        />

        <InputContainer

          label="DisplayOrder"
          name="DisplayOrder"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'DisplayOrder'

            )
          }}
          type="number"
          value={selectedServiceabilitys?.DisplayOrder}
        />

        <InputContainer

          label="Vendor Name"
          labelField="VendorName"
          list={vendors}
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'ServiceabilityTypeId'
            )
          }}
          optionName='Choose VendorName'
          type="select"
          value={selectedServiceabilitys?.ServiceabilityTypeId}
          valueField="Id"
        />

        <InputContainer

          label="StartDate"
          name="StartDateUtc"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'StartDateUtc'
            )
          }}
          type="date"
          value={selectedServiceabilitys?.StartDateUtc}
        />
        <InputContainer

          label="EndDate"
          name="EndDateUtc"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'EndDateUtc'
            )
          }}
          type="date"
          value={selectedServiceabilitys?.EndDateUtc}
        />

        <InputContainer

          label="Always Enabled"
          name="IsAlwaysEnabled"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event,
              'IsAlwaysEnabled'

            )
          }}
          type="checkbox"
          value={selectedServiceabilitys?.IsAlwaysEnabled}
        />

        <InputContainer

          label="Remarks"
          name="Remarks"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'Remarks'

            )
          }}
          type="text"
          value={selectedServiceabilitys?.Remarks}
        />
        <div className='col-span-full'>
          <InputContainer

            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'Description'

              )
            }}
            type="text"
            value={selectedServiceabilitys?.Description}
          />
        </div>


      </div>
    }
    expandedPanel="Basic Info"
    headerTitle="Basic Info"
  />
  </>

)
export default ServiceabilityBasicInfoComponent;
